import _ from "underscore";

export function unbindAll(views){
  _(views).each((view)=>{
    view.unbindListeners();
  });
}

export function extractElements(views){
  return views.map((view)=>{return view.getElement();});
}


// WEBPACK FOOTER //
// ./src/utilities/viewHelpers/index.js